import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useGetLanguage } from '@/hooks/useGetLanguage'

export const usePageAbout = () => {
  // 打开弹窗
  const { toolImg } = useGetLanguage()
  const showDialog = ref(false)
  function handleOpenDialog() {
    showDialog.value = true
  }

  const { t, locale } = useI18n()

  const courseData = ref([
    {
      time: '2022.9',
      desc: t('about.courseText1'),
    },
    {
      time: '2024.2',
      desc: t('about.courseText2'),
    },
    {
      time: '2024.5',
      desc: t('about.courseText3'),
    },
    {
      time: '2024.8',
      desc: t('about.courseText4'),
    },
    {
      time: '2024.9',
      desc: t('about.courseText5'),
    },
  ])
  return {
    toolImg,
    handleOpenDialog,
    showDialog,
    courseData,
    locale,
  }
}
